"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reduceEvents = exports.getSlideTimings = exports.getLayoutTimingsAutocast = exports.getLayoutTimings = exports.getLayoutActivationEvents = exports.getComponentEventByType = exports.getComponentByType = exports.clearScreenComponents = exports.clearComponentData = exports.calculateEventStartTime = void 0;
var _lodash = require("lodash");
var _constants = require("../EventPump/constants");
var _EventListReducer = _interopRequireDefault(require("../EventPump/EventListReducer"));
var _EventConstants = _interopRequireDefault(require("../models/EventConstants"));
var _moment = _interopRequireDefault(require("moment"));
var _componentData = require("../models/componentData");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ScreenTypesEnum = _EventConstants["default"].ScreenTypesEnum;
var strayCEMap = {};
var reduceEvents = exports.reduceEvents = function reduceEvents(model) {
  var eventList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return eventList.reduce(function (eventModel, _ref) {
    var _ref$payload = _ref.payload,
      payload = _ref$payload === void 0 ? {} : _ref$payload,
      startTimeOffsetInMillis = _ref.startTimeOffsetInMillis,
      _ref$timestamp = _ref.timestamp,
      timestamp = _ref$timestamp === void 0 ? null : _ref$timestamp,
      componentEventId = _ref.id,
      startTime = _ref.startTime;
    var type = payload.type,
      screenType = payload.screenType,
      screenId = payload.screenId,
      data = payload.data,
      componentId = payload.componentId;
    var newModel = _objectSpread({}, eventModel);
    var key = screenId + "_" + componentId;
    switch (type) {
      case _constants.CREATE_AUDIENCE_SCREEN:
        {
          var isDefaultScreen = payload.isDefaultScreen;
          var screenData = _EventListReducer["default"].getEmptyScreenModel({
            screenType: screenType,
            screenId: screenId,
            isDefaultScreen: isDefaultScreen
          });
          newModel.screens[screenId] = {
            screenId: screenId,
            title: screenData.title,
            timestamp: timestamp
          };
          break;
        }
      case _constants.EDIT_AUDIENCE_SCREEN:
        {
          newModel.screens[screenId] = _objectSpread(_objectSpread({}, newModel.screens[screenId]), {}, {
            title: data.title,
            timestamp: timestamp
          });
          break;
        }
      case _constants.CREATE_AUDIENCE_COMPONENT:
        {
          newModel.components[componentId] = _objectSpread(_objectSpread({}, newModel.components[componentId]), {}, {
            componentId: componentId,
            name: data.name,
            type: data.type,
            screenId: screenId,
            timestamp: timestamp
          });
          newModel.screenComponentMap[key] = _objectSpread(_objectSpread({}, newModel.screenComponentMap[key]), {}, {
            componentId: componentId,
            screenId: screenId
          });
          break;
        }
      case _constants.EDIT_AUDIENCE_COMPONENT:
        {
          var id = data.id;
          newModel.components[id] = _objectSpread(_objectSpread({}, newModel.components[id]), {}, {
            name: data.name,
            timestamp: timestamp
          });
          break;
        }
      case _constants.DELETE_AUDIENCE_COMPONENT:
        {
          var _payload$componentId = payload.componentId,
            _componentId = _payload$componentId === void 0 ? '' : _payload$componentId;
          // this is a 2 step process.. first we need to remove the component from
          // screenComponentMap
          if (!(0, _lodash.isEmpty)(newModel.screenComponentMap)) {
            delete newModel.screenComponentMap[key];
          }
          // then we loop through whats left and only delete from components
          // map if no other components are found
          var found = Object.values(newModel.screenComponentMap).find(function (item) {
            return item.componentId === _componentId;
          });
          if (!found) {
            delete newModel.components[_componentId];
          }
          break;
        }
      case _constants.DELETE_AUDIENCE_SCREEN:
        {
          // this is a 3 step process.. first, after storing associated components,
          // we remove any item from screenComponentMap which contains deleted screen
          var componentList = Object.values(newModel.screenComponentMap).filter(function (item) {
            return screenId === item.screenId;
          });
          Object.keys(newModel.screenComponentMap).forEach(function (key) {
            var scrId = newModel.screenComponentMap[key].screenId;
            if (scrId === screenId) {
              delete newModel.screenComponentMap[key];
            }
          });
          // second, we delete component from components map if no more exist
          componentList.forEach(function (item) {
            var found = Object.values(newModel.screenComponentMap).find(function (scr) {
              return item.componentId === scr.componentId;
            });
            if (!found) {
              delete newModel.components[item.componentId];
            }
          });
          // finally, we delete the screen from screens map
          if (!(0, _lodash.isEmpty)(newModel.screens)) {
            delete newModel.screens[screenId];
          }
          break;
        }
      case _constants.CHANGE_IFRAME_URL_AUDIENCE:
        {
          if (newModel.components[componentId]) {
            newModel.components[componentId].url = data.url;
          }
          break;
        }
      case _constants.UPDATE_MEETING_PULSE_AUDIENCE:
        {
          if (newModel.components[componentId]) {
            newModel.components[componentId].meetingPulse = data.meetingPulseId !== '';
          }
          break;
        }
      case _constants.CHANGE_IFRAME_PARAMS_AUDIENCE:
        {
          if (newModel.components[componentId]) {
            newModel.components[componentId].userDataParams = data.userDataParams;
          }
          break;
        }
      case _constants.ADD_SLIDESHOW_PDF:
        {
          var cId = data.componentId;
          newModel.components[cId] = _objectSpread(_objectSpread(_objectSpread({}, newModel.components[cId]), data), {}, {
            type: 'slideshow'
          });
          // always take timestamp of first pdf upload
          if (!newModel.components[cId].pdfUploadTimestamp) {
            newModel.components[cId].pdfUploadTimestamp = timestamp;
          }
          // add any slide timings that may have appeared before this component event
          strayCEMap[_constants.UPDATE_SLIDESHOW_INDEX] && strayCEMap[_constants.UPDATE_SLIDESHOW_INDEX].forEach(function (_ref2) {
            var componentEventId = _ref2.componentEventId,
              timecode = _ref2.timecode,
              index = _ref2.index,
              timestamp = _ref2.timestamp;
            newModel.components[cId] = _objectSpread(_objectSpread({}, newModel.components[cId]), {}, {
              slideTimings: _objectSpread(_objectSpread({}, newModel.components[cId].slideTimings), {}, _defineProperty({}, componentEventId, {
                componentEventId: componentEventId,
                timecode: timecode || 0,
                index: index,
                timestamp: timestamp
              }))
            });
          });
          break;
        }
      case _constants.UPDATE_SLIDESHOW_INDEX:
        {
          var _id = data.componentId,
            index = data.currentIndex;
          var _cId = _id;
          if (!_cId) {
            var component = getComponentByType(newModel.components, 'slideshow');
            _cId = component.componentId || component.id;
          }

          // archived component events use startTime in seconds
          // others use startTimeOffsetInMillis
          var timecode = -1;
          if (startTimeOffsetInMillis) {
            timecode = Math.round(startTimeOffsetInMillis / 1000);
          } else {
            timecode = Math.round(parseFloat(startTime));
          }

          // we need to check for existence of slideshow component
          // if not found, store current info for later addition and exit
          if ((0, _lodash.isUndefined)(newModel.components[_cId])) {
            var toInsert = {
              componentEventId: componentEventId,
              timecode: timecode || 0,
              index: index,
              timestamp: timestamp
            };
            if (strayCEMap[_constants.UPDATE_SLIDESHOW_INDEX]) {
              strayCEMap[_constants.UPDATE_SLIDESHOW_INDEX] = [].concat(_toConsumableArray(strayCEMap[_constants.UPDATE_SLIDESHOW_INDEX]), [toInsert]);
            } else {
              strayCEMap[_constants.UPDATE_SLIDESHOW_INDEX] = [toInsert];
            }
            return newModel;
          }
          if ((0, _lodash.isUndefined)(newModel.components[_cId].slideTimings)) {
            newModel.components[_cId].slideTimings = [];
          }

          // note: it's possible that there are multiples of an index,
          // so to avoid duplicates we're creating a map based on index
          // where we'll take the most recent occurrence of a given index
          newModel.components[_cId] = _objectSpread(_objectSpread({}, newModel.components[_cId]), {}, {
            slideTimings: _objectSpread(_objectSpread({}, newModel.components[_cId].slideTimings), {}, _defineProperty({}, componentEventId, {
              componentEventId: componentEventId,
              timecode: timecode || 0,
              index: index,
              timestamp: timestamp
            }))
          });
          break;
        }
      default:
        break;
    }
    return newModel;
  }, _objectSpread({}, model));
};
var getComponentByType = exports.getComponentByType = function getComponentByType() {
  var components = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var type = arguments.length > 1 ? arguments[1] : undefined;
  return Object.values(components).find(function (item) {
    return item.type === type;
  });
};
var getComponentEventByType = exports.getComponentEventByType = function getComponentEventByType() {
  var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var type = arguments.length > 1 ? arguments[1] : undefined;
  var filtered = list.filter(function (item) {
    return item.payload.type === type;
  });
  return filtered;
};
var getLayoutActivationEvents = exports.getLayoutActivationEvents = function getLayoutActivationEvents() {
  var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var layoutActivateEvents = list.filter(function (_ref3) {
    var _ref3$payload = _ref3.payload,
      _ref3$payload2 = _ref3$payload === void 0 ? {} : _ref3$payload,
      type = _ref3$payload2.type,
      _ref3$payload2$screen = _ref3$payload2.screenId,
      screenId = _ref3$payload2$screen === void 0 ? '' : _ref3$payload2$screen;
    return type === _constants.UPDATE_ACTIVE_AUDIENCE_SCREEN && screenId.includes(ScreenTypesEnum.EVENT);
  });
  return layoutActivateEvents;
};
var getSlideTimings = exports.getSlideTimings = function getSlideTimings(pdf) {
  var _pdf$slideTimings = pdf.slideTimings,
    slideTimings = _pdf$slideTimings === void 0 ? [] : _pdf$slideTimings;
  var timings = Object.values(slideTimings);
  var slidesBeforeEventStart = timings.filter(function (event) {
    return event && event.timecode < 0;
  });
  var slidesAfterEventStart = timings.filter(function (event) {
    return event && event.timecode >= 0;
  });
  var slideOne = slidesBeforeEventStart && slidesBeforeEventStart.length > 0 ? [slidesBeforeEventStart[slidesBeforeEventStart.length - 1]] : [];
  var sorted = [].concat(slideOne, _toConsumableArray(slidesAfterEventStart)).sort(function (a, b) {
    return a.timecode - b.timecode;
  });
  var filtered = sorted.reduce(function (obj, _ref4) {
    var componentEventId = _ref4.componentEventId,
      index = _ref4.index,
      timecode = _ref4.timecode;
    return _objectSpread(_objectSpread({}, obj), {}, _defineProperty({}, componentEventId, {
      id: componentEventId,
      index: index,
      timecode: timecode
    }));
  }, {});
  return filtered;
};
var getLayoutTimings = exports.getLayoutTimings = function getLayoutTimings(list) {
  var layoutActivateEvents = getLayoutActivationEvents(list);
  var timings = layoutActivateEvents.reduce(function (events, event) {
    var id = event.id,
      _event$payload = event.payload,
      _event$payload2 = _event$payload === void 0 ? {} : _event$payload,
      screenId = _event$payload2.screenId,
      startTime = event.startTime;
    return _objectSpread(_objectSpread({}, events), {}, _defineProperty({}, id, {
      id: id,
      timecode: Math.round(parseFloat(startTime)) || -1,
      screenId: screenId
    }));
  }, {});
  return timings;
};
var getLayoutTimingsAutocast = exports.getLayoutTimingsAutocast = function getLayoutTimingsAutocast(list) {
  var layoutActivateEvents = getLayoutActivationEvents(list);
  var layoutBeforeEventStart = layoutActivateEvents.filter(function (event) {
    return event.saveType === 'prestart';
  });
  var layoutAfterEventStart = layoutActivateEvents.filter(function (event) {
    return event.saveType === 'poststart';
  });
  var firstLayoutEvent = layoutBeforeEventStart && layoutBeforeEventStart.length > 0 ? [layoutBeforeEventStart[layoutBeforeEventStart.length - 1]] : [];
  var timings = [].concat(firstLayoutEvent, _toConsumableArray(layoutAfterEventStart)).reduce(function (events, event) {
    var id = event.id,
      _event$payload3 = event.payload,
      _event$payload4 = _event$payload3 === void 0 ? {} : _event$payload3,
      screenId = _event$payload4.screenId,
      startTimeOffsetInMillis = event.startTimeOffsetInMillis;
    return _objectSpread(_objectSpread({}, events), {}, _defineProperty({}, id, {
      id: id,
      timecode: Math.ceil(startTimeOffsetInMillis / 1000) || -1,
      screenId: screenId
    }));
  }, {});
  return timings;
};
var calculateEventStartTime = exports.calculateEventStartTime = function calculateEventStartTime(eventList) {
  var eventStartTime = null;
  var event = eventList.find(function (_ref5) {
    var _ref5$payload = _ref5.payload,
      _ref5$payload2 = _ref5$payload === void 0 ? {} : _ref5$payload,
      type = _ref5$payload2.type;
    return type === _constants.CREATE_AUDIENCE_COMPONENT;
  });
  if (event) {
    eventStartTime = (0, _moment["default"])(Date.parse(event.timestamp) - event.startTime * 1000).toISOString();
  } else {
    console.error('[ComponentEventUtils] Couldn\'t determine event start time.');
  }
  return eventStartTime;
};
var clearComponentData = exports.clearComponentData = function clearComponentData() {
  var model = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  model.polls = (0, _componentData.polls)();
  model.qa = (0, _componentData.qa)();
  model.surveys = (0, _componentData.surveys)();
  model.slideshow = (0, _componentData.slideshow)();
  return model;
};
var clearScreenComponents = exports.clearScreenComponents = function clearScreenComponents() {
  var model = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _model$screens = model.screens,
    screens = _model$screens === void 0 ? {} : _model$screens;
  Object.keys(screens).forEach(function (scr) {
    Object.keys(screens[scr].components).forEach(function (component) {
      if (screens[scr].components[component].type !== "av") {
        delete screens[scr].components[component];
      }
    });
  });
  return model;
};